module.exports = __webpack_public_path__ + "img/adcolony-icon.0cfbf92b.svg";